import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import Flex from "../Flex";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const StatsItem = ({ stat }) => {
  const { title, amount, caret, caretColor, icon } = stat;
  return (
    <div>
      <Flex
        justifyContent="center"
        alignItems="center"
        className="mb-3 position-static"
      >
        <p className="me-2 mb-0 shadow-none">{icon}</p>
        <h5 className="mb-0 flex-1">{title}</h5>
      </Flex>
      <Flex>
        <p className="font-sans-serif lh-1 mb-1  pe-2">
          {amount !== undefined ? (
            <span className="fs-4">
              <CountUp end={amount} duration={1} separator="," />
            </span>
          ) : (
            <Spinner animation="border" size="sm" />
          )}
        </p>
        <div className="d-flex flex-column">
          <FontAwesomeIcon
            icon={caret}
            className={`me-1 mb-0 text-${caretColor}`}
          />
        </div>
      </Flex>
    </div>
  );
};

function CardColumns({ statsData, data }) {
  const [stats, setStats] = useState(statsData);
  useEffect(() => {
    setStats(statsData);
  }, [data]);
  const navigate = useNavigate();

  return (
    <Card>
      <Card.Body>
        <Row className="d-flex">
          {stats.map((stat, index) => (
            <Col
              key={index + 1}
              className={
                "flex-1" +
                classNames({
                  "border-bottom border-lg-0 border-lg-end":
                    index !== stats.length - 1,
                  "pb-3 pb-lg-0": index === 0,
                  "py-3 py-lg-0": index === 1,
                  "pt-3 pt-lg-0": index === 2,
                })
              }
            >
              {stat.title === "Total Customers" ? (
                <span
                  onClick={() => {
                    navigate("/dashboard/home/assigned-orders?pageNumber=1");
                  }}
                  className="d-block text-primary cursor-pointer"
                >
                  <StatsItem stat={stat} />
                </span>
              ) : (
                <StatsItem stat={stat} />
              )}
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default CardColumns;
